import { createSlice, createAction } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

export const getUnreadCount = createAction(
  'patientConversation/getUnreadCount'
);

// Slice
const patientConversationSlice = createSlice({
  name: 'patientConversation',
  initialState: initialStore.patientConversation,
  reducers: {
    getChannels: (state, { payload }) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setChannels: (state, { payload }) => {
      if (state.isLoading) {
        state.isLoading = false;
      }
      state.data = payload;
      if (payload?.channels?.length) {
        state.selectedChannel = payload?.channels[0].channelId;
      }
    },
    getChannelsFail: (state) => {
      if (state.isLoading) {
        state.isLoading = false;
      }
    },
    setChannel: (state, { payload }) => {
      state.selectedChannel = payload;
    },
    setUnreadCount: (state, { payload }) => {
      state.unreadCount = payload;
    }
  }
});

export const {
  getChannels,
  setChannels,
  getChannelsFail,
  setChannel,
  setUnreadCount
} = patientConversationSlice.actions;

export const { reducer } = patientConversationSlice;

// Selectors
export const getPatientConversationChannelsSelector = (state: IState) =>
  state && state.patientConversation.data;

export const getPatientConversationSelectedChannelSelector = (state: IState) =>
  state && state.patientConversation.selectedChannel;

export const getUnreadCountSelector = (state: IState) =>
  state && state.patientConversation.unreadCount;
